module.exports = __webpack_public_path__ + "img/Heads _ Tails.ecc1b1f3.jpg";